import { combineReducers, createStore, compose, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import global from '../modules/global/async';
import { createMiddleware } from 'redux-beacon';
import logger from '@redux-beacon/logger';
import GoogleAnalytics, { trackPageView } from '@redux-beacon/google-analytics';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import Debug from 'debug';

import { LOCATION_CHANGE } from 'connected-react-router';
import { SITES } from 'lib/constants';

const envPath = process.env.REACT_APP_BASENAME;
const site = SITES[window.location.pathname.split('/')[1]] || SITES['com'];
const basename = `${site.path}/${envPath}`;

const error = Debug('mnd:store:error');

const configureStore = ({ initialState = {}, history, i18n }) => {
  const eventsMap = {
    [LOCATION_CHANGE]: trackPageView(action => {
      return {
        page: `${basename}${action.payload.location.pathname}`,
        location: window.location.href,
      };
    }),
  };

  const gaMiddleware = createMiddleware(eventsMap, GoogleAnalytics(), {
    logger: Debug.enabled('mnd:store:logger') && logger,
  });

  const sagaMiddleware = createSagaMiddleware({
    onError: err => {
      error(err);
    },
  });

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

  const middleware = [
    sagaMiddleware,
    routerMiddleware(history),
    window.ga && gaMiddleware,
  ].filter(i => i);

  const store = createStore(
    store => store,
    initialState,
    composeEnhancers(applyMiddleware(...middleware)),
  );
  const asyncReducers = { router: connectRouter(history) };
  const asyncSagas = [];

  store.injectReducers = ({ name, reducers }) => {
    if (reducers && !asyncReducers[name]) {
      asyncReducers[name] = reducers;
      store.replaceReducer(combineReducers(asyncReducers));
      store.dispatch({ type: `${name}/REDUCERS_LOADED` });
    }
  };

  store.injectSagas = ({ name, sagas }) => {
    if (sagas && !asyncSagas.includes(name)) {
      asyncSagas.push(name);
      sagaMiddleware.run(sagas, i18n);
      store.dispatch({ type: `${name}/SAGAS_LOADED` });
    }
  };

  // if (process.env.NODE_ENV === 'development') {
  //   if (module.hot) {
  //     module.hot.accept('../modules/global', () => {
  //       store.replaceReducer(combineReducers(store.asyncReducers))
  //     })
  //   }
  // }
  store.injectReducers({ ...global, store: store });
  store.injectSagas({ ...global, store: store });
  return store;
};

export default configureStore;
